var React = require('react');

function IconPlus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.7 6.8c-.1-.2-.2-.5-.3-.7 0-.1-.1-.2-.2-.4-.2-.5-.5-.9-.8-1.3-.3-.4-.7-.8-1-1.1C14 2 12.1 1.2 10 1.2S6.1 2 4.6 3.3c-.1 0-.1.1-.2.2C2.9 5 2 7 2 9.2s.9 4.2 2.4 5.7l.3.3c1.4 1.3 3.3 2.1 5.4 2.1s4-.8 5.4-2.1c.4-.4.7-.7 1-1.1.3-.4.6-.9.8-1.3 0-.1.1-.2.2-.4s.2-.5.3-.7c.1-.9.2-1.7.2-2.5 0-.9-.1-1.7-.3-2.4zM10 16.2c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7c0 3.8-3.1 7-7 7z","key":0}),React.createElement("path",{"d":"M12.7 8.6h-2.2V6.3c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2.3H7.3c-.3 0-.5.2-.5.5s.2.5.5.5h2.2v2.5c0 .3.2.5.5.5s.5-.2.5-.5V9.6h2.2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z","key":1})]);
}

IconPlus.defaultProps = {"x":"0","y":"0","version":"1.1","viewBox":"0 0 20 19","xmlSpace":"preserve"};

module.exports = IconPlus;

IconPlus.default = IconPlus;
